import { useContext } from "react";
import { useForm } from "react-hook-form";
import { SetPasswordStatus } from "../../../shared/services/api/cloud/auth";
import { IdentityProviderClientContext } from "../../../shared/services/api/contexts";
import { useSnackbar } from "../../../shared/components/layout/SnackbarContext";
import { unknownType } from "../../../shared/utils/assert";

type FormValues = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

export function UserProfileChangePassword() {
  const auth = useContext(IdentityProviderClientContext);
  const { showSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<FormValues>();
  const onSubmit = handleSubmit(async (data) => {
    if (data.newPassword !== data.confirmPassword) {
      setError("confirmPassword", { message: "Passwords do not match." });
      return;
    }
    let status: SetPasswordStatus;
    try {
      status = await auth.setPassword(data.oldPassword, data.newPassword);
    } catch (e) {
      showSnackbar({ text: "Cannot update password", color: "danger" });
      throw e;
    }
    switch (status) {
      case SetPasswordStatus.Success:
        reset();
        break;
      case SetPasswordStatus.IncorrectOldPassword:
        setError("oldPassword", { message: "Incorrect password." });
        break;
      case SetPasswordStatus.IncorrectOldPasswordLimitExceeded:
        setError("oldPassword", { message: "Incorrect password." });
        showSnackbar({
          text: "Incorrect password limit exceeded. Please try again later.",
          color: "danger",
        });
        break;
      default:
        unknownType(status);
    }
  });
  return (
    <>
      <h2>Change password</h2>
      <hr />
      <form onSubmit={onSubmit}>
        <div className="block">
          <div className="field">
            <label className="label" htmlFor="oldPassword">
              Old password
            </label>
            <p className="control">
              <input
                id="oldPassword"
                type="password"
                className={errors.oldPassword ? "is-danger input" : "input"}
                {...register("oldPassword", { required: "Field required." })}
              />
            </p>
            <p className="help is-danger">{errors.oldPassword?.message}</p>
          </div>
          <div className="field">
            <label className="label" htmlFor="newPassword">
              New password
            </label>
            <p className="control">
              <input
                id="newPassword"
                type="password"
                className={errors.newPassword ? "is-danger input" : "input"}
                {...register("newPassword", { required: "Field required." })}
              />
            </p>
            <p className="help is-danger">{errors.newPassword?.message}</p>
          </div>
          <div className="field">
            <label className="label" htmlFor="confirmPassword">
              Confirm new password
            </label>
            <p className="control">
              <input
                id="confirmPassword"
                type="password"
                className={errors.confirmPassword ? "is-danger input" : "input"}
                {...register("confirmPassword", { required: "Field required." })}
              />
            </p>
            <p className="help is-danger">{errors.confirmPassword?.message}</p>
            <p className="help">
              Make sure it's at least 15 characters OR at least 8 characters including a number and
              a lowercase letter.
            </p>
          </div>
          <button className="button">Update password</button>
        </div>
      </form>
    </>
  );
}
